import React, { useState, useRef } from "react";
import { isEmpty, get } from "lodash";
import { Image, Tabs, Tab, InputGroup, Button, Form } from "react-bootstrap";
import { ConfigureTransformations } from "./ConfigureTransformations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FormControlSearch } from "../../../components";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-light-svg-icons";
import { UnmappedField } from "./UnmappedField";
import { AddCustomFields } from "./AddCustomFields";
import { Droppable } from "react-beautiful-dnd";
import { TargetDroppedContainer } from "./TargetDropedContainer";
import { default as uuid } from "uuid";
import { deleteGroups } from "./MapperFunctions";

const pageIndexes = [
  "Personal Information",
  "Contact Information",
  "Employment & Age details",
  "Employee Classification",
  "Hours and Compensation",
  "Loan",
  "Contribution",
];

const TargetContainer = (props) => {
  const {
    dragStart,
    requiredData,
    destination,
    characters,
    configurations,
    onCancelConfigure,
    addConfigureSlider,
    setFieldOperations,
    setTargetField,
    ssnExist,
    rkPlanNumberExist,
    uploadedFileType,
    deleteCT,
    fileName,
  } = props;
  const [keyValue, setkeyValue] = useState(
    uploadedFileType === 8
      ? "Incorporation details"
      : uploadedFileType === 9
      ? "Plan details"
      : "Personal information"
  );
  const [customFields, setCustomFields] = useState([]);
  const [addFieldSlider, setConfigure] = useState(false);
  const [sliderItem, setItem] = useState(null);
  const [addGroupCount, setAddGroupCount] = useState(0);
  const renderChildObjectMaps = (e) => {
    if (!e.childObjectMaps || e.childObjectMaps.length === 0) {
      return [];
    }

    return e.childObjectMaps.map((f, ind) => (
      <>
        {!isEmpty(f.displayName) && (
          <Droppable droppableId={f.id + "," + e.id}>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="mw-100"
              >
                {!isEmpty(f.path) &&
                characters?.find(
                  (x) =>
                    x.fieldName?.replaceAll("/", "") ==
                    f.path?.replaceAll("/", "")
                ) ? (
                  <TargetDroppedContainer
                    item={f}
                    mappedObject={
                      !isEmpty(characters) &&
                      characters.find(
                        (g) =>
                          g.fieldName.replaceAll("/", "") ==
                          f.path.replaceAll("/", "")
                      )
                    }
                    collectionId={e.id}
                    setConfigure={setConfigure}
                    setItem={setItem}
                    configuredTransformations={configurations}
                    initialData={requiredData}
                    deleteCT={deleteCT}
                    setTargetField={setTargetField}
                    addFieldSlider={addConfigureSlider}
                    onCancel={onCancelConfigure}
                    setFieldOperations={setFieldOperations}
                  />
                ) : (
                  <UnmappedField
                    dragStart={dragStart}
                    columnName={f.displayName}
                    isselected={f.isRequired}
                    provided={provided}
                    isDragging={snapshot.isDragging}
                    isDraggingOver={snapshot.isDraggingOver}
                    ssnExist={ssnExist}
                    rkPlanNumberExist={rkPlanNumberExist}
                    ref={provided.innerRef}
                    destination={destination}
                    characters={characters}
                    handleOnDragEnd={props.handleOnDragEnd}
                    id={f.id}
                    droppableId={f.id + "," + e.id}
                  />
                )}
              </div>
            )}
          </Droppable>
        )}
        {renderChildObjectMaps(f)}
      </>
    ));
  };
  const onCancel = () => {
    setConfigure(false);
  };
  const MappingInformation =
    !isEmpty(requiredData) &&
    requiredData
      .sort((a, b) => {
        return a.sortOrder - b.sortOrder;
      })
      .reduce((res, data) => {
        if (!res[data.groupName]) {
          res[data.groupName] = [];
        }
        res[data.groupName].push(data);
        return res;
      }, {});
  const addGroups = (item) => {
    const processChildObject = (childObject) => {
      if (!isEmpty(childObject)) {
        const processedChildObject = {
          ...childObject,
          fieldOperations: [],
          path: null,
          dataSource: 1,
          id: uuid.v4(),
        };

        const processedChildObjects = processedChildObject.childObjectMaps.map(
          (f) => processChildObject(f)
        );

        return {
          ...processedChildObject,
          childObjectMaps: processedChildObjects,
        };
      }

      return { ...childObject, id: 0 };
    };

    const childObjects = requiredData
      .find((e) => e.id == item.id)
      .childObjectMaps.map(processChildObject);

    console.log("qwqw", childObjects);

    const addGroup = [
      ...requiredData,
      {
        //id: uuid.v4(),
        id: uuid.v4(),
        isCollection: true,
        isCollectionStart: false,
        isCollectionEnd: false,
        childObjectMaps: childObjects,
        groupName: item.groupName,
        propertyName: item.propertyName,
        dataType: 1,
        format: "",
        fieldLength: 15,
        sortOrder: item.sortOrder,
      },
    ];
    const collections = addGroup.filter((e) => e.groupName == item.groupName);
    const collectionsData = collections.map((e, i) => {
      if (i === 0) {
        if (collections.length === 1) {
          return {
            ...e,
            isCollectionStart: true,
            isCollectionEnd: true,
          };
        }
        return {
          ...e,
          isCollectionStart: true,
          isCollectionEnd: false,
        };
      }

      if (i === collections.length - 1) {
        return {
          ...e,
          isCollectionStart: false,
          isCollectionEnd: true,
        };
      }
      return {
        ...e,
        isCollectionStart: false,
        isCollectionEnd: false,
      };
    });
    setTargetField([
      ...addGroup.filter((e) => e.groupName != item.groupName),
      ...collectionsData,
    ]);
  };
  const myRef = useRef(null);

  const slideLeft = (e) => {
    myRef.current.scrollLeft -= 100;
  };
  const slideRight = (e) => {
    myRef.current.scrollLeft += 100;
  };

  const [searchBar, showSearchBar] = useState(false);
  const [dropdown, showdropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    isEmpty(event.target.value) ? showdropdown(false) : showdropdown(true);
    let array_value = event.target.value.split("\\");

    if (array_value[1]) {
      setkeyValue(pageIndexes[array_value[0].trim()]);
    }
  };

  return (
    <div className="main-target-container">
      <div className="main-target">
        <p className="target-text">Target</p>
        <div className="searchIconContainer">
          <Button
            variant="link"
            onClick={() => {
              showSearchBar(!searchBar);
            }}
            className="search-with-api-button"
          >
            <Image className="searchIcon" src="/assets/icons/svg/search.svg" />
          </Button>
        </div>
      </div>

      {searchBar && (
        <Form className="w-95-padleft-20" style={{ zIndex: "1", width: "92%" }}>
          <InputGroup>
            <div className="d-flex w-100 border border-1 border-bottom-0 rounded shadow-sm">
              <FormControlSearch
                size="sm"
                id="target-search-box"
                type="text"
                className="w-100 border-0"
                placeholder="Search target fields here"
                autoComplete="off"
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.keyCode === 13) {
                    e.preventDefault();
                  }
                }}
                onChange={handleChange}
              />
            </div>
          </InputGroup>

          {(() => {
            if (dropdown) {
              return (
                <div className="search-drop-down rounded-bottom border border-1 border-top-0 shadow-sm">
                  {Object.entries(MappingInformation).map(
                    ([groupName, data1]) => (
                      <div className="border-top py-1">
                        <p className="pt-1 m-0 text-muted">{groupName}</p>
                        <ul className="drop-down-ul">
                          {data1
                            .filter((element) => {
                              if (
                                "displayName" in element &&
                                element.displayName
                                  .toLowerCase()
                                  .includes(searchTerm.toLowerCase())
                              ) {
                                return true;
                              }
                            })
                            .map((element) => (
                              <li
                                className="drop-down-li"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setkeyValue(groupName);
                                  setSearchTerm(element.displayName);
                                  showdropdown(false);
                                }}
                              >
                                {element.displayName}
                              </li>
                            ))}
                          {data1.filter((element) => {
                            if (
                              "displayName" in element &&
                              element.displayName
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            ) {
                              return true;
                            }
                          }).length == 0 ? (
                            <li>
                              <p className="text-secondary p-0 m-0">
                                No records found
                              </p>{" "}
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </div>
                    )
                  )}
                </div>
              );
            }
          })()}
        </Form>
      )}

      <div className="d-flex">
        <Button
          variant="link"
          className="left-arrow-div"
          onClick={(e) => slideLeft(e)}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
        <div
          className="target-tabs"
          ref={myRef}
          style={{ maxWidth: "84%", width: "84vw" }}
        >
          <Tabs
            defaultActiveKey={
              uploadedFileType === 8
                ? "Incorporation details"
                : uploadedFileType === 9
                ? "Plan details"
                : "Personal information"
            }
            transition={false}
            activeKey={keyValue}
            onSelect={(k) => setkeyValue(k)}
            className="top-level-tab-enrollment"
            mountOnEnter
            unmountOnExit
          >
            {Object.entries(MappingInformation).map(([groupName, data]) => {
              if (groupName != "undefined") {
                return (
                  <Tab
                    eventKey={groupName}
                    title={
                      <span
                        style={{
                          display: "inline-flex",
                          whiteSpace: "nowrap",
                        }}
                        className={
                          keyValue == groupName
                            ? "groupNameChange"
                            : "groupNameChangeHover"
                        }
                      >
                        {groupName}
                        <div>
                          {!isEmpty(data) &&
                            data.reduce((acc, val) => {
                              return (
                                acc || val.groupName == "Personal Information"
                              );
                            }, false) && <div style={{ color: "red" }}>*</div>}
                        </div>
                      </span>
                    }
                  >
                    <div
                      className="target-fields-container"
                      style={{ width: "86.5%" }}
                    >
                      {console.log("843", requiredData)}
                      {console.log("asd", data)}
                      {console.log("pqs", MappingInformation)}
                      {data.map((e, i) => {
                        console.log("l34", e);
                        if (
                          searchTerm == "" ||
                          ("displayName" in e &&
                            searchTerm &&
                            e.displayName
                              .trim()
                              .toLowerCase()
                              .includes(searchTerm.trim().toLowerCase()))
                        ) {
                          if (e.isComplex) {
                            {
                              console.log("compp", e);
                            }
                            return <>{renderChildObjectMaps(e)}</>;
                          }
                          if (!e.isCollection) {
                            return (
                              <>
                                {!isEmpty(e.displayName) && (
                                  <Droppable droppableId={e.id}>
                                    {(provided, snapshot) => (
                                      <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        className="mw-100"
                                      >
                                        {!isEmpty(e.path) &&
                                        characters?.find(
                                          (x) =>
                                            x.fieldName?.replaceAll("/", "") ==
                                            e.path?.replaceAll("/", "")
                                        ) ? (
                                          <TargetDroppedContainer
                                            item={e}
                                            mappedObject={
                                              !isEmpty(characters) &&
                                              characters.find((f) => {
                                                return (
                                                  f.fieldName.replaceAll(
                                                    "/",
                                                    ""
                                                  ) ==
                                                  e.path.replaceAll("/", "")
                                                );
                                              })
                                            }
                                            configurations={
                                              !isEmpty(configurations) &&
                                              configurations.length > 1
                                                ? configurations.find(
                                                    (f) =>
                                                      f.propertyName ==
                                                      e.propertyName
                                                  )
                                                : !isEmpty(configurations)
                                                ? configurations.find(
                                                    (f) =>
                                                      f.propertyName ==
                                                      e.propertyName
                                                  )
                                                  ? configurations
                                                  : null
                                                : null
                                            }
                                            setConfigure={setConfigure}
                                            setItem={setItem}
                                            configuredTransformations={
                                              configurations
                                            }
                                            initialData={requiredData}
                                            deleteCT={deleteCT}
                                            setTargetField={setTargetField}
                                            addFieldSlider={addConfigureSlider}
                                            onCancel={onCancelConfigure}
                                            setFieldOperations={
                                              setFieldOperations
                                            }
                                          />
                                        ) : (
                                          <UnmappedField
                                            dragStart={dragStart}
                                            columnName={e.displayName}
                                            isselected={e.isRequired}
                                            provided={provided}
                                            ssnExist={ssnExist}
                                            rkPlanNumberExist={
                                              rkPlanNumberExist
                                            }
                                            isDragging={snapshot.isDragging}
                                            isDraggingOver={
                                              snapshot.isDraggingOver
                                            }
                                            ref={provided.innerRef}
                                            destination={destination}
                                            characters={characters}
                                            handleOnDragEnd={
                                              props.handleOnDragEnd
                                            }
                                            id={e.id}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </Droppable>
                                )}
                                {/* <>{renderChildObjectMaps(e)}</> */}
                              </>
                            );
                          }
                          if (e.isCollection) {
                            return (
                              <>
                                {e.isCollectionStart ? (
                                  <div
                                    style={{
                                      pointerEvents:
                                        addGroupCount >= 9 &&
                                        e.groupName == "Service records"
                                          ? "none"
                                          : "",
                                    }}
                                    className="add-group-style"
                                    onClick={() => {
                                      setAddGroupCount(addGroupCount + 1);
                                      addGroups(e);
                                    }}
                                  >
                                    <i className="fas fa-plus mt-1"></i> Add
                                    Group
                                  </div>
                                ) : null}
                                <>{renderChildObjectMaps(e)}</>
                                {e.isCollectionStart &&
                                e.isCollectionEnd ? null : (
                                  <div className="d-flex">
                                    {data.length != 1 && (
                                      <FontAwesomeIcon
                                        style={{
                                          marginLeft: "16.8rem",
                                          cursor: "pointer",
                                        }}
                                        className="payroll-delete"
                                        icon={faTrashAlt}
                                        size="20px"
                                        color="#EB5757"
                                        onClick={() =>
                                          deleteGroups(
                                            e,
                                            setTargetField,
                                            requiredData
                                          )
                                        }
                                      />
                                    )}
                                    {/* <div
                                    className="transform-target-text"
                                    style={{
                                      color: "#2F80ED",
                                      cursor: "pointer",
                                      marginLeft: "auto",
                                    }}
                                    onClick={() => addGroups(e)}
                                  >
                                    <i
                                      style={{ color: "#4F4F4F" }}
                                      className="fas fa-plus mt-1"
                                    ></i>{" "}
                                    Add Group
                                  </div> */}
                                  </div>
                                )}
                                <hr style={{ width: "100%" }} />
                              </>
                            );
                          }
                          //}
                        }
                      })}
                    </div>
                  </Tab>
                );
              }
            })}
          </Tabs>
        </div>
        <Button
          variant="link"
          className="right-arrow-div"
          onClick={(e) => slideRight(e)}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </div>
      {addFieldSlider && !isEmpty(sliderItem) && (
        <ConfigureTransformations
          setTargetField={setTargetField}
          initialData={requiredData}
          itemConfigure={sliderItem}
          configuredValues={
            !isEmpty(configurations)
              ? configurations.find(
                  (f) =>
                    f.propertyName == get(sliderItem, "object.propertyName")
                )
              : null
          }
          addFieldSlider={addFieldSlider}
          onCancel={onCancel}
          setFieldSlider={setConfigure}
          setFieldOperations={setFieldOperations}
          fileName={fileName}
        />
      )}
      {/* {addFieldSlider && (
        <AddCustomFields
          addFieldSlider={addFieldSlider}
          onCancel={onCancel}
          customFields={customFields}
          setCustomFields={setCustomFields}
          //setFieldSlider={setFieldSlider}
        />
      )} */}
    </div>
  );
};

export default TargetContainer;
